module.exports = __webpack_public_path__ + "static/media/holidays-696x394.b5eb566e.png";